import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

interface Props {
    imageId: string;
  images: Array<any>;
  title: string;
  width?: string;
  height?: string;
  align?: string;
  inline?: boolean;
  verticalAlign?: string;
}

const ImageWidget = ({ imageId, images, title, width, height, align, verticalAlign, inline }: Props) => {
  let asset = null;
  if (imageId && images)
    asset = images.filter(x => x.assetId === imageId)[0];

  const getWidth = () => (width ? width : "100%")
  const getHeight = () => (height ? height : "100%")
  const getAlign = () => (align ? align : "left")
  const getDisplay = () => (inline ? "inline-block" : "flex")
  const getVerticalAlign = () => (verticalAlign ? verticalAlign : "initial")

  return (
    <div style={{display: getDisplay(), justifyContent: getAlign(), verticalAlign: getVerticalAlign()}}>
      <div style={{width: getWidth(), height: getHeight(), verticalAlign: "middle", display: "flex", }}>
        {asset && <GatsbyImage image={asset.localFile.childImageSharp.gatsbyImageData} title={title} alt={title} />}
      </div>
    </div>
  );
}

ImageWidget.NAME = "ImageWidget";
export default ImageWidget
